import { t } from 'i18next';
import * as yup from 'yup';

import { addressSchema } from 'addresses/schemas';
import { ContactGroupType } from 'contacts/enums';
import { getEmptyErrorMessage } from 'core/yup';
import { externalCustomerNumberSchema } from 'quotes/components';

export const locationSchema = (
  contactGroupType: ContactGroupType,
  isAlternateVersionEnabled: boolean
) => {
  const baseSchema = addressSchema();

  return baseSchema.shape({
    contactGroup: yup
      .object()
      .label(t('labelCompany'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelCompany'))),
    ...(contactGroupType === ContactGroupType.CUSTOMER && {
      customerNumber: externalCustomerNumberSchema(false, isAlternateVersionEnabled),
      isShipTo: yup.boolean().label(t('labelShipTo')).required(),
      isBillTo: yup.boolean().label(t('labelBillTo')).required(),
    }),
  });
};
